import { render, staticRenderFns } from "./bgset.vue?vue&type=template&id=31f91990&scoped=true&"
import script from "./bgset.vue?vue&type=script&lang=js&"
export * from "./bgset.vue?vue&type=script&lang=js&"
import style0 from "./bgset.vue?vue&type=style&index=0&id=31f91990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f91990",
  null
  
)

export default component.exports